import React, { useState, useEffect } from 'react';
import './LatestArticlesSkeleton.scss';

const LatestArticlesSkeleton = () => {
    const [visibleArticles, setVisibleArticles] = useState(3);

    const updateArticlesCount = () => {
        if (window.innerWidth >= 1920) {
            setVisibleArticles(4);
        } else if (window.innerWidth >= 1200) {
            setVisibleArticles(3);
        }
    };

    useEffect(() => {
        updateArticlesCount();
        window.addEventListener('resize', updateArticlesCount);
        return () => window.removeEventListener('resize', updateArticlesCount);
    }, []);

    return (
        <div className="latest__articles__skeleton">
            <div className="latest__articles__title__skeleton"></div>
            <div className={`articles__skeleton articles-${visibleArticles}`}>
                {[...Array(visibleArticles)].map((_, i) => (
                    <div key={i} className="article__card__skeleton">
                        <div className="article__link__skeleton">
                            <div className="article__image__skeleton"></div>
                            <div className="article__info__skeleton">
                                <div className='article__info__date__wrapper__skeleton'>
                                    <div className="article__category__skeleton"></div>
                                    <div className="article__date__skeleton"></div>
                                </div>
                                {[...Array(2)].map((_, index) => (
                                    <div key={index} className="article__title__skeleton"></div>
                                ))}
                                <div className="article__title__skeleton--primary"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LatestArticlesSkeleton;